export enum RIGHTS {
  ACCESS_OPERATOR_RECEVABILITY = 'ACCESS_OPERATOR_RECEVABILITY',
  ACCESS_OPERATOR_RECEVABILITY_SELF = 'ACCESS_OPERATOR_RECEVABILITY_SELF',
  ACCESS_PSAP_RECEVABILITY = 'ACCESS_PSAP_RECEVABILITY',
  ACCESS_PSAP_RECEVABILITY_SELF = 'ACCESS_PSAP_RECEVABILITY_SELF',
  ACCESS_STATS = 'ACCESS_STATS',
  CONFIRM_OPERATOR_RECEVABILITY = 'CONFIRM_OPERATOR_RECEVABILITY',
  CONFIRM_PSAP_INITIALIZATION = 'CONFIRM_PSAP_INITIALIZATION',
  CONFIRM_PSAP_RECEVABILITY = 'CONFIRM_PSAP_RECEVABILITY',
  CONSULT_DOCS = 'CONSULT_DOCS',
  CONSULT_WS_LOGS = 'CONSULT_WS_LOGS',
  CREATE_USER_ANY = 'CREATE_USER_ANY',
  CREATE_USER_AUTHORITY_STATE = 'CREATE_USER_AUTHORITY_STATE',
  CREATE_USER_MINISTER = 'CREATE_USER_MINISTER',
  CREATE_USER_OPERATOR = 'CREATE_USER_OPERATOR',
  CREATE_USER_OPERATOR_MANAGER = 'CREATE_USER_OPERATOR_MANAGER',
  CREATE_USER_PSAP = 'CREATE_USER_PSAP',
  CREATE_USER_PSAP_INTEGRATOR = 'CREATE_USER_PSAP_INTEGRATOR',
  CREATE_USER_PSAP_MANAGER = 'CREATE_USER_PSAP_MANAGER',
  DELETE_USERS = 'DELETE_USERS',
  EVENTS_MANAGEMENT = 'EVENTS_MANAGEMENT',
  INITIATE_OPERATOR = 'INITIATE_OPERATOR',
  INITIATE_PSAP = 'INITIATE_PSAP',
  MODIFY_ATTACHED_PSAP = 'MODIFY_ATTACHED_PSAP',
  MODIFY_ATTACHED_PSAP_THRESHOLD = 'MODIFY_ATTACHED_PSAP_THRESHOLD',
  MODIFY_EVENTS = 'MODIFY_EVENTS',
  MODIFY_HIS_OPERATOR_INFOS = 'MODIFY_HIS_OPERATOR_INFOS',
  MODIFY_HIS_PSAP_INFOS = 'MODIFY_HIS_PSAP_INFOS',
  MODIFY_OPERATOR = 'MODIFY_OPERATOR',
  MODIFY_PSAP = 'MODIFY_PSAP',
  MODIFY_OWN = 'MODIFY_OWN',
  MODIFY_OWN_RECEVABILITY = 'MODIFY_OWN_RECEVABILITY',
  MODIFY_PSAP_THRESHOLD = 'MODIFY_PSAP_THRESHOLD',
  MODIFY_SVH_ELIGIBILITY = 'MODIFY_SVH_ELIGIBILITY',
  RECEVABILITY_OPERATOR_AGREEMENT_APNF = 'RECEVABILITY_OPERATOR_AGREEMENT_APNF',
  RECEVABILITY_OPERATOR_AGREEMENT_WORLDLINE = 'RECEVABILITY_OPERATOR_AGREEMENT_WORLDLINE',
  RECEVABILITY_OPERATOR_GETADDRESS_TEST_WAITING = 'RECEVABILITY_OPERATOR_GETADDRESS_TEST_WAITING',
  RECEVABILITY_OPERATOR_GETLOCATIONSVH_TEST_WAITING = 'RECEVABILITY_OPERATOR_GETLOCATIONSVH_TEST_WAITING',
  RECEVABILITY_OPERATOR_NOTIFYOPERATOR_TEST_WAITING = 'RECEVABILITY_OPERATOR_NOTIFYOPERATOR_TEST_WAITING',
  RECEVABILITY_OPERATOR_PRESHARED_KEY_WAITING = 'RECEVABILITY_OPERATOR_PRESHARED_KEY_WAITING',
  RECEVABILITY_OPERATOR_PUSHLOCATION_TEST_WAITING = 'RECEVABILITY_OPERATOR_PUSHLOCATION_TEST_WAITING',
  RECEVABILITY_OPERATOR_PUSHLOCATIONSVH_TEST_WAITING = 'RECEVABILITY_OPERATOR_PUSHLOCATIONSVH_TEST_WAITING',
  RECEVABILITY_OPERATOR_VPN_CONFIG_WAITING = 'RECEVABILITY_OPERATOR_VPN_CONFIG_WAITING',
  RECEVABILITY_OPERATOR_VPN_TEST_WAITING = 'RECEVABILITY_OPERATOR_VPN_TEST_WAITING',
  RECEVABILITY_OPERATOR_WAITING_CGU_VALIDATION = 'RECEVABILITY_OPERATOR_WAITING_CGU_VALIDATION',
  RECEVABILITY_OPERATOR_WL_VPN_CONFIG_WAITING = 'RECEVABILITY_OPERATOR_WL_VPN_CONFIG_WAITING',
  RECEVABILITY_OPERATOR_WL_VPN_TEST_WAITING = 'RECEVABILITY_OPERATOR_WL_VPN_TEST_WAITING',
  RECEVABILITY_PSAP_AGREEMENT_APNF = 'RECEVABILITY_PSAP_AGREEMENT_APNF',
  RECEVABILITY_PSAP_AGREEMENT_CPM = 'RECEVABILITY_PSAP_AGREEMENT_CPM',
  RECEVABILITY_PSAP_AGREEMENT_WORLDLINE = 'RECEVABILITY_PSAP_AGREEMENT_WORLDLINE',
  RECEVABILITY_PSAP_CONFIG_SSL = 'RECEVABILITY_PSAP_CONFIG_SSL',
  RECEVABILITY_PSAP_TERMINAL_LOCALISATION_PULL_SVH_TEST = 'RECEVABILITY_PSAP_TERMINAL_LOCALISATION_PULL_SVH_TEST',
  RECEVABILITY_PSAP_TERMINAL_LOCATION_PUSH_TEST = 'RECEVABILITY_PSAP_TERMINAL_LOCATION_PUSH_TEST',
  RECEVABILITY_PSAP_TERMINAL_LOCATION_PULL_TEST = 'RECEVABILITY_PSAP_TERMINAL_LOCATION_PULL_TEST',
  RECEVABILITY_PSAP_WAITING_CGU_VALIDATION = 'RECEVABILITY_PSAP_WAITING_CGU_VALIDATION',
  RECEVABILITY_PSAP_WAITING_INFOS_SSL = 'RECEVABILITY_PSAP_WAITING_INFOS_SSL',
  RECEVABILITY_PSAP_GOING_INTO_PRODUCTION = 'RECEVABILITY_PSAP_GOING_INTO_PRODUCTION',
  VIEW_ALL_OPERATOR = 'VIEW_ALL_OPERATOR',
  VIEW_ALL_PSAP = 'VIEW_ALL_PSAP',
  VIEW_ATTACHED_PSAP = 'VIEW_ATTACHED_PSAP',
  VIEW_HIS_USERS = 'VIEW_HIS_USERS',
  VIEW_OPERATOR_IN_SERVICE = 'VIEW_OPERATOR_IN_SERVICE',
  VIEW_PSAP_IN_SERVICE = 'VIEW_PSAP_IN_SERVICE',
  VIEW_PSAP_OF_MINISTER = 'VIEW_PSAP_OF_MINISTER',
  VIEW_SVH_ELIGIBILITY = 'VIEW_SVH_ELIGIBILITY',
  VIEW_USERS = 'VIEW_USERS',
  VIEW_USERS_NOT_ADMIN = 'VIEW_USERS_NOT_ADMIN',
  VIEW_USERS_OF_OPERATOR = 'VIEW_USERS_OF_OPERATOR',
  VIEW_USERS_OF_PSAP = 'VIEW_USERS_OF_PSAP',
  VIEW_USERS_PSAP_INTEGRATORS = 'VIEW_USERS_PSAP_INTEGRATORS',
  VIEW_USERS_MINISTER = 'VIEW_USERS_MINISTER',
  VIEW_USERS_STATE_AUTHORITY = 'VIEW_USERS_STATE_AUTHORITY'
}
